<ng-container *appI18nScopeReady>
  <h2 mat-dialog-title>{{ (data.mode === 'create' ? 'title.new' : 'title.edit') | i18n }}</h2>

  <mat-dialog-content>
    <mat-form-field appearance="outline" class="name-field">
      <mat-label>{{ 'report_name' | i18n }}</mat-label>
      <input
        matInput
        [(ngModel)]="name"
        required
        [placeholder]="'report_name_placeholder' | i18n"
      />
      @if (hasDuplicateName()) {
        <mat-error>{{ 'error.name_duplicate' | i18n }}</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" class="period-field">
      <mat-label>{{ 'report_period' | i18n }}</mat-label>
      <mat-date-range-input [rangePicker]="periodPicker">
        <input
          matStartDate
          [(ngModel)]="periodStartDate"
          required
          [placeholder]="'start_date' | i18n"
        />
        <input
          matEndDate
          [(ngModel)]="periodEndDate"
          required
          [placeholder]="'end_date' | i18n"
        />
      </mat-date-range-input>
      <mat-datepicker-toggle matIconSuffix [for]="periodPicker" />
      <mat-date-range-picker #periodPicker />
      @if (isPeriodSelectionMissing()) {
        <mat-error>{{ 'error.report_period_incomplete' | i18n }}</mat-error>
      } @else if (hasInvalidPeriodRange()) {
        <mat-error>{{ 'error.report_period_invalid' | i18n }}</mat-error>
      }
    </mat-form-field>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="cancel()">{{ 'cancel_btn' | i18n }}</button>
    <button mat-flat-button (click)="apply()" [disabled]="!canApply()">
      {{ 'save_changes_btn' | i18n }}
    </button>
  </mat-dialog-actions>
</ng-container>

